export default __webpack_public_path__ + "static/media/gallery_30.3e05a8a4.jpg";